import(/* webpackMode: "eager" */ "/home/live/crm_nextjs_v1/src/app/page.tsx")